<template>
  <div><show style="width: 100%;height: 100%;"></show></div>
</template>
<script>
import Show from './Show'
export default {
  name: 'CenterTwo',
  components: {
    Show
  }
}

</script>


// WEBPACK FOOTER //
// src/components/CenterTwo.vue